export default __webpack_public_path__ + "static/media/labirynt.a7ffa314.png";